import { render, staticRenderFns } from "./Lieferantenanalyse.vue?vue&type=template&id=6fbfcd58&"
import script from "./Lieferantenanalyse.vue?vue&type=script&lang=ts&"
export * from "./Lieferantenanalyse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports